import { useEffect, useRef } from 'react';

import { sendEvent } from '@/lib/ga4';
import { trpc } from '@/lib/trpc';
import { stepStore } from '@/stores/steps';

export const useFlowTracker = <T>({ flow, dataMapper }: { flow: string; dataMapper: () => T }) => {
  const startTime = useRef(new Date());
  const lastEvent = useRef(new Date());

  const createMutation = trpc.flow.create.useMutation({
    retry: 2,
    retryDelay: 1000,
    onError: () => {
      // ignore
    }
  });

  useEffect(() => {
    const listener = ({ step }: { step: string }) => {
      const now = new Date();
      const fromStart = now.getTime() - startTime.current.getTime();
      const fromLastEvent = now.getTime() - lastEvent.current.getTime();

      lastEvent.current = now;

      const data = {
        flow,
        step,
        fromStart,
        fromLastEvent,
        ...dataMapper()
      };

      createMutation.mutate(data);
      sendEvent(`flow_${flow}_step_${step}`, 'change_step');
    };

    stepStore.getState().addListener(listener);

    return () => {
      stepStore.getState().removeListener(listener);
    };
  }, [createMutation, dataMapper, flow]);
};
